import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5969f9ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wish-info" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex-1f name ellipsis" }
const _hoisted_4 = { class: "d-flex tag-box" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex-1f"
}
const _hoisted_6 = { class: "row3" }
const _hoisted_7 = { class: "price" }
const _hoisted_8 = { class: "price-original" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_tag = _resolveComponent("van-tag")!

  return (_openBlock(), _createElementBlock("div", {
    class: "wish-card",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goGoodsDetails && _ctx.goGoodsDetails(...args)))
  }, [
    _createVNode(_component_RatioHeightContainer, { ratio: 100 }, {
      default: _withCtx(() => [
        _createVNode(_component_van_image, {
          width: "100%",
          height: "175px",
          alt: "图片加载中...",
          fit: "cover",
          src: _ctx.getCoverImg(_ctx.data.img)
        }, null, 8, ["src"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.data.productTag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.productTag.split(','), (item) => {
                return (_openBlock(), _createBlock(_component_van_tag, {
                  key: item,
                  class: "tag",
                  plain: "",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, "￥" + _toDisplayString(_ctx.data.presentPrice), 1),
        _createElementVNode("span", _hoisted_8, "￥" + _toDisplayString(_ctx.data.originalPrice), 1)
      ])
    ])
  ]))
}